import script from "./NumberSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./NumberSetting.vue?vue&type=script&setup=true&lang=ts"

import "./NumberSetting.vue?vue&type=style&index=0&id=790db0df&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-790db0df"]])

export default __exports__